import { getYear } from "@rentiohq/shared-frontend/dist/utils/date-fns.utils";
export var MAX_YEARS = 120;
export var defineYearAmount = function (params) {
    var minDate = params.minDate, maxDate = params.maxDate;
    if (minDate && maxDate) {
        var difference = getYear(maxDate) - getYear(minDate);
        return Math.max(1, Math.min(MAX_YEARS, difference + 1));
    }
    return MAX_YEARS;
};
// The month/year picker only knows about a month and a year, so it needs a full
// date to build the new value from. Falling back to today would produce a date
// outside of the allowed range whenever min/max dates are in the past, which
// then gets silently clamped to that boundary instead of the picked month.
export var getMonthYearAnchorDate = function (params) {
    var selected = params.selected, minDate = params.minDate, maxDate = params.maxDate;
    if (selected instanceof Date) {
        return selected;
    }
    if (maxDate instanceof Date) {
        return maxDate;
    }
    if (minDate instanceof Date) {
        return minDate;
    }
    return new Date();
};
export var getSelectableMonths = function (params) {
    var year = params.year, minDate = params.minDate, maxDate = params.maxDate, selected = params.selected;
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].filter(function (month) {
        // An already stored value can fall outside of the current min/max range
        // (e.g. when editing older data), it should stay visible in the dropdown
        if (selected instanceof Date &&
            getYear(selected) === year &&
            selected.getMonth() === month) {
            return true;
        }
        if (minDate instanceof Date &&
            getYear(minDate) === year &&
            month < minDate.getMonth()) {
            return false;
        }
        if (maxDate instanceof Date &&
            getYear(maxDate) === year &&
            month > maxDate.getMonth()) {
            return false;
        }
        return true;
    });
};
export var defineStartYear = function (params) {
    var minDate = params.minDate, maxDate = params.maxDate, yearAmountBase = params.yearAmount;
    var yearAmount = Math.max(1, Math.min(MAX_YEARS, yearAmountBase || 0));
    if (minDate) {
        return getYear(minDate);
    }
    if (maxDate) {
        return getYear(maxDate) - yearAmount + 1;
    }
    return getYear(new Date()) - Math.round(yearAmount / 2);
};
